export const SUPPORTED_LANGUAGES = [
  { code: "zh", nativeName: "简体中文", htmlLang: "zh-CN", dir: "ltr", currency: "CNY" },
  { code: "zh-hant", nativeName: "繁體中文", htmlLang: "zh-Hant", dir: "ltr", currency: "TWD" },
  { code: "en", nativeName: "English", htmlLang: "en", dir: "ltr", currency: "USD" },
  { code: "de", nativeName: "Deutsch", htmlLang: "de", dir: "ltr", currency: "EUR" },
  { code: "pt", nativeName: "Português", htmlLang: "pt", dir: "ltr", currency: "BRL" },
  { code: "es", nativeName: "Español", htmlLang: "es", dir: "ltr", currency: "EUR" },
  { code: "fr", nativeName: "Français", htmlLang: "fr", dir: "ltr", currency: "EUR" },
  { code: "it", nativeName: "Italiano", htmlLang: "it", dir: "ltr", currency: "EUR" },
  { code: "hi", nativeName: "हिंदी", htmlLang: "hi", dir: "ltr", currency: "INR" },
  { code: "ru", nativeName: "Русский", htmlLang: "ru", dir: "ltr", currency: "RUB" },
  { code: "ko", nativeName: "한국어", htmlLang: "ko", dir: "ltr", currency: "KRW" },
  { code: "ja", nativeName: "日本語", htmlLang: "ja", dir: "ltr", currency: "JPY" },
  { code: "th", nativeName: "ภาษาไทย", htmlLang: "th", dir: "ltr", currency: "THB" },
  { code: "tr", nativeName: "Türkçe", htmlLang: "tr", dir: "ltr", currency: "TRY" },
  { code: "vi", nativeName: "Tiếng Việt", htmlLang: "vi", dir: "ltr", currency: "VND" },
  { code: "nl", nativeName: "Nederlands", htmlLang: "nl", dir: "ltr", currency: "EUR" },
  { code: "id", nativeName: "Bahasa Indonesia", htmlLang: "id", dir: "ltr", currency: "IDR" },
  { code: "ar", nativeName: "العربية", htmlLang: "ar", dir: "rtl", currency: "AED" },
  { code: "pl", nativeName: "Polski", htmlLang: "pl", dir: "ltr", currency: "PLN" },
];

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);

export const DOMESTIC_LOCALE = "zh";

/** 简体 / 繁体均走国内联系方式（电话 / 微信） */
export const DOMESTIC_LOCALE_CODES = ["zh", "zh-hant"];

export const INTERNATIONAL_LOCALE_CODES = SUPPORTED_LANGUAGE_CODES.filter(
  (code) => !DOMESTIC_LOCALE_CODES.includes(code)
);

export function isDomesticLocale(code) {
  return DOMESTIC_LOCALE_CODES.includes(code);
}

export function getLanguageMeta(code) {
  return (
    SUPPORTED_LANGUAGES.find((l) => l.code === code) || SUPPORTED_LANGUAGES[0]
  );
}

export function getLanguageNativeName(code) {
  return getLanguageMeta(code).nativeName;
}
